import { GeocodingProviderEnum } from '~/enums'
import { selectProvider } from '~/lib/geo-providers/selectProvider'

interface Provider {
  name: string
  accessToken: string
}

export function getProviderConfig() {
  const providers: Record<GeocodingProviderEnum, Provider> = {
    [GeocodingProviderEnum.MAPBOX]: {
      name: 'Mapbox',
      accessToken: useRuntimeConfig().public.mapboxApiKey
    },
    [GeocodingProviderEnum.GOOGLE]: {
      name: 'Google Places',
      accessToken: useRuntimeConfig().public.googleApiKey
    }
  }

  const currentProvider = selectProvider(useRuntimeConfig().public)

  const provider = providers[currentProvider]
  return { providers, currentProvider, provider }
}
